import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ButtonBack } from "../Button/Back";
import { getMessagemErro } from "../../utils/erro";
import api from "../../services/api";
import './SolicitacaoCadastroArquivosGrandesVolumes.css';
import { SolicitacaoArquivoGrandesVolumesAttachmentsAndHistory } from "./AttachmentsAndHistory";
import { ArquivoGrandesVolumesDetails } from "./Details";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

export const SolicitacaoArquivoGrandesVolumesView =

withRouter(

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				solicitacao: {
					id: undefined,
					cedenteDosDados: undefined,
					esferasAdministrativas: [],
					cpfDirigenteTi: '',
					cpfResponsavelTecnico: '',
					titulo: "",
					descricao: "",
					arquivos: [],
					justificativa: '',
				},
				executouCarregamento: false,
				botoesHabilitados: true,
				exibeModalConfirmacao: false,
				msgModal: '',
				operacao: null,
			};
			this.handleInputChange = this.handleInputChange.bind(this);
			this.confirmaOperacao = this.confirmaOperacao.bind(this);
			this.aprovarSolicitacao = this.aprovarSolicitacao.bind(this);
			this.rejeitarSolicitacao = this.rejeitarSolicitacao.bind(this);
		
		
		}

		componentDidMount(){
			this.props.limpaMensagem();
			const id = this.props.match.params.id;
			this.props.mostraAguardando();

			api.get(`/api/solicitacao-cadastro-arquivo-gv/${id}`)
				.then(response => { 
					const solicitacao = response.data;
					this.setState({ solicitacao, executouCarregamento: true }) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar a solicitação de adesão.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.finally(() => {
					this.props.escondeAguardando();
				});
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>Solicitação de Cadastro de Arquivo Grandes Volumes</h1>
					</div>
					<div className="div-form">
						{this.state.executouCarregamento && this.renderForm()}
					</div>
				</main>
			);
		}

		renderForm() {
			const solicitacao = this.state.solicitacao;

			return(
				<div className="container-fluid">
					
					<ArquivoGrandesVolumesDetails solicitacao={solicitacao} mostraDetalhesAprovacao={false} mostraDetalhesPastaSegura={true}/>
					
					 <div className="br-form">
						<SolicitacaoArquivoGrandesVolumesAttachmentsAndHistory solicitacao={solicitacao} habilitaEdicaoAnexo={false}/>

						<div className="actions-button">
							<div className="actions justify-content-start">
								{solicitacao.aprovacaoAdministradorPermitida && 
									<Link to={`/arquivo-grandes-volumes/approve/${solicitacao.id}`}>
										<button type="button" className="button is-primary">Analisar</button>
									</Link>
								}

								{ solicitacao.alteracaoPermitida &&
									<Link to={`/arquivo-grandes-volumes/edit/${solicitacao.id}`}>
										<button type="button" className="button is-primary botaoNovo">Alterar</button>
									</Link>
								}

								{ solicitacao.configuracaoPastaSeguraPermitida &&
									<Link to={`/arquivo-grandes-volumes/pasta-segura/${solicitacao.id}`}>
										<button type="button" className="button is-primary botaoNovo">Configurar Pasta Segura</button>
									</Link>
								}

								<ButtonBack disabled={!this.state.botoesHabilitados} />								
							</div>
						</div>
					</div> 
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const solicitacao = this.state.solicitacao;
			solicitacao[nome] = valor;
			this.setState({ solicitacao });
		}

		handleInputNumberChange(nomePropriedade, valoresInput){
			const solicitacao = this.state.solicitacao;
			solicitacao[nomePropriedade] = Number(valoresInput.value);
			this.setState({ solicitacao });
		}
	
		confirmaOperacao(operacao, msgModal, validacao) {
			if(validacao) {
				try{
					validacao();
				}catch(erroValidacao){
					return;
				}
			}

			this.setState(
				{
					exibeModalConfirmacao: true,
					operacao,
					msgModal,
				}
			);
		}

		executaOperacao () {
			this.setState({botoesHabilitados:false});
			this.props.limpaMensagem();
			this.props.mostraAguardando();
			window.scrollTo(0, 0)

			this.state.operacao();
			this.fechaModal();
		}

		executaAndamento (url, mensagemSucesso, mensagemErro) {
			const { solicitacao } = this.state;
			const { id, justificativaOrgaoFornecedor, justificativaOrgaoAdministrador, volumetriaAutorizada } = solicitacao;

			const options = {
				method: 'put',
				url,
				data: { id, justificativaOrgaoFornecedor, justificativaOrgaoAdministrador, volumetriaAutorizada },
			}

			api(options)
				.then(response => { 
					this.setState({
						solicitacao: response.data,
						pesquisaExecutada : true,
					}) 
					this.props.exibeMensagemSucesso(mensagemSucesso);
				})
				.catch(erro => {
					const msg = getMessagemErro(mensagemErro, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then (() =>{
					this.setState({botoesHabilitados:true});
					this.props.escondeAguardando();
				});
		}

		aprovarSolicitacao () {
			const mensagemSucesso = "Solicitação de adesão aprovada com sucesso.";
			const mensagemErro = "Não foi possível aprovar a solicitação de adesão.";
			const url = '/api/solicitacao-cadastro-arquivo-gv/deferir';
			this.executaAndamento(url, mensagemSucesso, mensagemErro);
		}

		rejeitarSolicitacao() {
			const mensagemSucesso = "Solicitação de adesão rejeitada com sucesso.";
			const mensagemErro = "Não foi possível rejeitar a solicitação de adesão.";
			const url = '/api/solicitacao-cadastro-arquivo-gv/rejeitar-administrador';
			this.executaAndamento(url, mensagemSucesso, mensagemErro);
		}

		fechaModal () {
			this.setState(
				{
					exibeModalConfirmacao: false,
				}
			);
		}
	}

) // redux
); // router